'use client'; // Error component must be a Client Component

import '@/component/style/app.css';

import { UnauthorizedPage } from '@/component/feature/auth/UnauthorizedPage';
import { MobileFirstAppLayout } from '@/component/layout/MobileFirstAppLayout/MobileFirstAppLayout';
import { Column } from '@/component/parts/layout/Column/Column';
import { unauthorizedErrorName } from '@/domain/auth/error/UnauthorizedError';

export default function Error({ error }: { error: Error }) {
  if (error.name === unauthorizedErrorName) {
    return <UnauthorizedPage />;
  }

  return <GeneralErrorPage />;
}

const GeneralErrorPage: React.FC = () => (
  <MobileFirstAppLayout>
    <Column spacing="10px">
      <h2>エラーが発生しました。</h2>
      <p>時間をおいて再度お試しください。</p>
    </Column>
  </MobileFirstAppLayout>
);
